/*
 * @file: login.js
 * @description: It is Container login screen .
 * @author: navreet
 */
import React, { Component, useState, useEffect } from 'react'
import Loader from '../../components/Loader'
import Logo from '../../components/logo/logo'
import './login.css'
import { LocalForm, Control } from 'react-redux-form'
import Errors from '../../components/common/errors'
import { Row, Col, FormGroup, Input } from 'reactstrap'
import Match from '../../utilities/validation'
import { Link } from 'react-router-dom'
import { invalidEmail, invalidPass, emptyEmail, emptyPassword } from '../../utilities/message'
import { useSelector, useDispatch } from 'react-redux'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { login } from '../../actions/user'
import { setForgotEmail } from '../../actions/user'


const Login = (props) => {
    const loaders = useSelector((state) => state.loader)
    const { history } = props
    const [pass, setPass] = useState(true)
    const user = useSelector((state) => state.user)

    const [emailVal, setEmailVal] = useState(user.email)
    const [passVal, setPassVal] = useState(user.password)
    const dispatch = useDispatch()
    const [checked, setChecked] = useState(user.checked)
    const [openError, setError] = useState(false)
    const [message, setMessage] = useState('')

    useEffect(() => {
        dispatch(setForgotEmail(null))
        if (user.checked) {
            setEmailVal(user.email)
            setPassVal(user.password)
        }
    }, [])

    const handleChange = (e) => {
        e.preventDefault()
    }

    const emailInputVal = (event) => {
        setEmailVal(event.target.value.replace(/\s/g, '').trim())
    }
    const passInputVal = (event) => {
        setPassVal(event.target.value.replace(/\s/g, ''))
    }

    // Handle user login
    const handleLogin = (values) => {
        dispatch(
            login({ email: emailVal, password: passVal }, checked, (res, message, data) => {
                if (res) {
                    history.push('/dashboard')
                } else {
                    setError(true)
                    setMessage(message)
                }
            }),
        )
    }

    return (
        <div className="login-form row div1">
            <Loader loading={loaders.isFetching} />
            {/* <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={6}> */}
            <div className="firstdiv col-sm-6">
                <div className="inner-form-wrapper">
                    <div className="sub-heading d-flex ">
                        <div className="col-sm-8 col-12">
                            <p className="heading1">
                                Welcome back! <img src={require('../../assets/images/hand.png')} />{' '}
                                <br />
                            </p>
                            {/* <br /> */}
                            <p className="heading2">Please log into your account to continue.</p>
                        </div>
                    </div>
                    <div className="center-div">
                        <LocalForm model="user" onSubmit={(values) => handleLogin(values)}>
                            <Row className="container">
                                <Col sm="12" md="12">
                                    <FormGroup>
                                        <div className="input-wrapper">
                                            <i class="  icon">
                                                <img src={require('../../assets/images/newfile/Email.svg').default} />
                                            </i>
                                            <Control.text
                                                model="user.email"
                                                className="form-control email input-field"
                                                id="user.email"
                                                value={emailVal}
                                                defaultValue={emailVal}
                                                placeholder="Email"
                                                onChange={(e) => emailInputVal(e)}
                                                errors={{
                                                    emptyEmail: (val) => !val,
                                                    invalidEmail: (val) =>
                                                        val && !Match.validateEmail(val.trim()),
                                                }}
                                            />
                                        </div>
                                        <Errors
                                            model="user.email"
                                            errors={{
                                                emptyEmail,
                                                invalidEmail,
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm="12" md="12">
                                    <FormGroup>
                                        <div className="input-wrapper">
                                            <i class="  icon">
                                                <img
                                                    src={require('../../assets/images/newfile/password icon.svg').default}
                                                />
                                            </i>
                                            <Control.text
                                                model="user.password"
                                                className="form-control input-field password"
                                                id="user.password"
                                                value={passVal}
                                                onChange={(e) => passInputVal(e)}
                                                onPaste={(e) => handleChange(e)}
                                                defaultValue={passVal}
                                                onCopy={(e) => handleChange(e)}
                                                type={pass ? 'password' : 'text'}
                                                placeholder="Password"
                                                errors={{
                                                    emptyPassword: (val) => !val,
                                                    // invalidPass: (val) => val && val.length < 5
                                                }}
                                            ></Control.text>
                                            {pass && (
                                                <i class="  iconeye" onClick={() => setPass(false)}>
                                                    <img
                                                        src={require('../../assets/images/newfile/hide password.svg').default}
                                                    />
                                                </i>
                                            )}

                                            {!pass && (
                                                <i class="  iconeye" onClick={() => setPass(true)}>
                                                    <img
                                                        src={require('../../assets/images/newfile/show password.svg').default}
                                                    />
                                                </i>
                                            )}
                                        </div>
                                        <Errors
                                            model="user.password"
                                            errors={{
                                                emptyPassword,
                                                invalidPass,
                                            }}
                                        />
                                    </FormGroup>
                                </Col>

                                <Col sm="12 form-button-spacing">
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            gap: '10px',
                                        }}
                                    >
                                        <FormControlLabel
                                            value="end"
                                            control={
                                                <Checkbox
                                                    onChange={() => setChecked(!checked)}
                                                    checked={checked}
                                                    className="rememberme"
                                                    sx={{
                                                        color: '#777C80',
                                                        '&.Mui-checked': {
                                                            color: '#442580',
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Remember Me"
                                            labelPlacement="end"
                                        />

                                        <span>
                                            <Link
                                                className="forgotLink"
                                                activeClassName="active"
                                                exact
                                                to="/forgotPassword"
                                            >
                                                Forgot Password?
                                            </Link>
                                        </span>
                                    </div>
                                    <div>
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-block "
                                        >
                                            Sign In
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </LocalForm>
                    </div>
                </div>
            </div>
            {/* </Grid>
        <Grid item xs={12} sm={12} md={6}> */}
            <div className="loginside col-sm-6">
                <div className="heading-text">
                    <div className="heading">
                        <Logo />
                    </div>
                    <h1 className="beelineHeading">City of Glendale</h1>
                    <p>Climate Mobility Executive Dashboard</p>
                </div>

            </div>

        </div>
    )
}

export default Login
